import React, { useState, useRef, useEffect } from 'react';
import { MdDelete } from 'react-icons/md';
import Button from 'components/Button';
import TextField from 'components/TextField';
import Section from '../../components/Section';
import WrapperInput from 'components/WrapperInput';
import PageNavigator from 'components/PageNavigator';
import {
  Container,
  FieldLabel,
  Row,
  MunicipioList,
  MunicipioItem,
  DeleteButton,
  InputWrapper,
  ButtonWrapper,
  ActionButtons,
  ActionButton,
  EmptyState,
  AutocompleteWrapper,
  AutocompleteDropdown,
  AutocompleteItem,
  UfPercursoContainer,
  UfInputField,
  UfListContainer,
  UfListItem,
  PaginationContainer,
  ItemsPerPageSelect,
} from './styles';

// Lista de municípios brasileiros (exemplo - você pode expandir ou buscar de uma API)
const MUNICIPIOS_BRASIL = [
  'Adamantina', 'Adolfo', 'Aguaí', 'Agudos', 'Alambari', 'Altinópolis', 'Alto Alegre',
  'Americana', 'Amparo', 'Andradina', 'Angatuba', 'Aparecida', 'Araçatuba', 'Araçoiaba da Serra',
  'Araraquara', 'Araras', 'Arco-Íris', 'Arealva', 'Areias', 'Areiópolis', 'Ariranha',
  'Artur Nogueira', 'Arujá', 'Assis', 'Atibaia', 'Auriflama', 'Avaí', 'Avanhandava',
  'Avaré', 'Bady Bassitt', 'Balbinos', 'Bálsamo', 'Bananal', 'Barão de Antonina',
  'Barbosa', 'Bariri', 'Barra Bonita', 'Barra do Chapéu', 'Barra do Turvo', 'Barretos',
  'Barrinha', 'Barueri', 'Bastos', 'Batatais', 'Bauru', 'Bebedouro', 'Bento de Abreu',
  'Bernardino de Campos', 'Bertioga', 'Bilac', 'Birigui', 'Biritiba-Mirim', 'Boa Esperança do Sul',
  'Bocaina', 'Bofete', 'Boituva', 'Bom Jesus dos Perdões', 'Bom Sucesso de Itararé', 'Borá',
  'Boracéia', 'Borborema', 'Borebi', 'Botucatu', 'Bragança Paulista', 'Braúna',
  'Brejo Alegre', 'Brodowski', 'Brotas', 'Buri', 'Buritama', 'Buritizal', 'Cabrália Paulista',
  'Cabreúva', 'Caçapava', 'Cachoeira Paulista', 'Caconde', 'Cafelândia', 'Caiabu',
  'Caieiras', 'Caiuá', 'Cajamar', 'Cajati', 'Cajobi', 'Cajuru', 'Campina do Monte Alegre',
  'Campinas', 'Campo Limpo Paulista', 'Campos do Jordão', 'Campos Novos Paulista', 'Cananéia',
  'Canas', 'Cândido Mota', 'Cândido Rodrigues', 'Canitar', 'Capão Bonito', 'Capela do Alto',
  'Capivari', 'Caraguatatuba', 'Carapicuíba', 'Cardoso', 'Casa Branca', 'Cássia dos Coqueiros',
  'Castilho', 'Catanduva', 'Catiguá', 'Cedral', 'Cerqueira César', 'Cerquilho', 'Cesário Lange',
  'Charqueada', 'Chavantes', 'Clementina', 'Colina', 'Colômbia', 'Conchal', 'Conchas',
  'Cordeirópolis', 'Coroados', 'Coronel Macedo', 'Corumbataí', 'Cosmópolis', 'Cosmorama',
  'Cotia', 'Cravinhos', 'Cristais Paulista', 'Cruzália', 'Cruzeiro', 'Cubatão', 'Cunha',
  'Descalvado', 'Diadema', 'Dirce Reis', 'Divinolândia', 'Dobrada', 'Dois Córregos',
  'Dolcinópolis', 'Dourado', 'Dracena', 'Duartina', 'Dumont', 'Echaporã', 'Eldorado',
  'Elias Fausto', 'Elisiário', 'Embaúba', 'Embu', 'Embu-Guaçu', 'Emilianópolis', 'Engenheiro Coelho',
  'Espírito Santo do Pinhal', 'Espírito Santo do Turvo', 'Estiva Gerbi', 'Estrela d\'Oeste',
  'Estrela do Norte', 'Euclides da Cunha Paulista', 'Fartura', 'Fernando Prestes', 'Fernandópolis',
  'Fernão', 'Ferraz de Vasconcelos', 'Flora Rica', 'Floreal', 'Florínia', 'Flórida Paulista',
  'Franca', 'Francisco Morato', 'Franco da Rocha', 'Gabriel Monteiro', 'Gália', 'Garça',
  'Gastão Vidigal', 'Gavião Peixoto', 'General Salgado', 'Getulina', 'Glicério', 'Guaiçara',
  'Guaimbê', 'Guaíra', 'Guapiaçu', 'Guapiara', 'Guará', 'Guaraçaí', 'Guaraci', 'Guarani d\'Oeste',
  'Guarantã', 'Guararapes', 'Guararema', 'Guaratinguetá', 'Guareí', 'Guariba', 'Guarujá',
  'Guarulhos', 'Guatapará', 'Guzolândia', 'Herculândia', 'Holambra', 'Hortolândia', 'Iacanga',
  'Iacri', 'Iaras', 'Ibaté', 'Ibirá', 'Ibirarema', 'Ibitinga', 'Ibiúna', 'Icém', 'Iepê',
  'Igaraçu do Tietê', 'Igarapava', 'Igaratá', 'Iguape', 'Ilha Comprida', 'Ilha Solteira',
  'Ilhabela', 'Indaiatuba', 'Indiana', 'Indiaporã', 'Inúbia Paulista', 'Ipaussu', 'Iperó',
  'Ipeúna', 'Ipiguá', 'Iporanga', 'Ipuã', 'Iracemápolis', 'Irapuã', 'Irapuru', 'Itaberá',
  'Itaí', 'Itajobi', 'Itaju', 'Itanhaém', 'Itaóca', 'Itapecerica da Serra', 'Itapetininga',
  'Itapeva', 'Itapevi', 'Itapira', 'Itapirapuã Paulista', 'Itápolis', 'Itaporanga', 'Itapuí',
  'Itapura', 'Itaquaquecetuba', 'Itararé', 'Itariri', 'Itatiba', 'Itatinga', 'Itirapina',
  'Itirapuã', 'Itobi', 'Itu', 'Itupeva', 'Ituverava', 'Jaborandi', 'Jaboticabal', 'Jacareí',
  'Jaci', 'Jacupiranga', 'Jaguariúna', 'Jales', 'Jambeiro', 'Jandira', 'Jardinópolis',
  'Jarinu', 'Jaú', 'Jeriquara', 'Joanópolis', 'João Ramalho', 'José Bonifácio', 'Júlio Mesquita',
  'Jumirim', 'Jundiaí', 'Junqueirópolis', 'Juquiá', 'Juquitiba', 'Lagoinha', 'Laranjal Paulista',
  'Lavínia', 'Lavrinhas', 'Leme', 'Lençóis Paulista', 'Limeira', 'Lindóia', 'Lins', 'Lorena',
  'Lourdes', 'Louveira', 'Lucélia', 'Lucianópolis', 'Luís Antônio', 'Luiziânia', 'Lupércio',
  'Lutécia', 'Macatuba', 'Macaubal', 'Macedônia', 'Magda', 'Mairinque', 'Mairiporã', 'Manduri',
  'Marabá Paulista', 'Maracaí', 'Marapoama', 'Mariápolis', 'Marília', 'Marinópolis', 'Martinópolis',
  'Matão', 'Mauá', 'Mendonça', 'Meridiano', 'Mesópolis', 'Miguelópolis', 'Mineiros do Tietê',
  'Mira Estrela', 'Miracatu', 'Mirandópolis', 'Mirante do Paranapanema', 'Mirassol', 'Mirassolândia',
  'Mococa', 'Mogi das Cruzes', 'Mogi Guaçu', 'Moji Mirim', 'Mombuca', 'Monções', 'Mongaguá',
  'Monte Alegre do Sul', 'Monte Alto', 'Monte Aprazível', 'Monte Azul Paulista', 'Monte Castelo',
  'Monte Mor', 'Monteiro Lobato', 'Morro Agudo', 'Morungaba', 'Motuca', 'Murutinga do Sul',
  'Nantes', 'Narandiba', 'Natividade da Serra', 'Nazaré Paulista', 'Neves Paulista', 'Nhandeara',
  'Nipoã', 'Nova Aliança', 'Nova Campina', 'Nova Canaã Paulista', 'Nova Castilho', 'Nova Europa',
  'Nova Granada', 'Nova Guataporanga', 'Nova Independência', 'Nova Luzitânia', 'Nova Odessa',
  'Novais', 'Novo Horizonte', 'Nuporanga', 'Ocauçu', 'Óleo', 'Olímpia', 'Onda Verde', 'Oriente',
  'Orindiúva', 'Orlândia', 'Osasco', 'Oscar Bressane', 'Osvaldo Cruz', 'Ourinhos', 'Ouro Verde',
  'Ouroeste', 'Pacaembu', 'Palestina', 'Palmares Paulista', 'Palmeira d\'Oeste', 'Palmital',
  'Panorama', 'Paraguaçu Paulista', 'Paraibuna', 'Paraíso', 'Paranapanema', 'Paranapuã', 'Parapuã',
  'Pardinho', 'Pariquera-Açu', 'Parisi', 'Patrocínio Paulista', 'Paulicéia', 'Paulínia', 'Paulistânia',
  'Paulo de Faria', 'Pederneiras', 'Pedra Bela', 'Pedranópolis', 'Pedregulho', 'Pedreira',
  'Pedrinhas Paulista', 'Pedro de Toledo', 'Penápolis', 'Pereira Barreto', 'Pereiras', 'Peruíbe',
  'Piacatu', 'Piedade', 'Pilar do Sul', 'Pindamonhangaba', 'Pindorama', 'Pinhalzinho', 'Piquerobi',
  'Piquete', 'Piracaia', 'Piracicaba', 'Piraju', 'Pirajuí', 'Pirangi', 'Pirapora do Bom Jesus',
  'Pirapozinho', 'Pirassununga', 'Piratininga', 'Pitangueiras', 'Planalto', 'Platina', 'Poá',
  'Poloni', 'Pompéia', 'Pongaí', 'Pontal', 'Pontalinda', 'Pontes Gestal', 'Populina', 'Porangaba',
  'Porto Feliz', 'Porto Ferreira', 'Potim', 'Potirendaba', 'Pracinha', 'Pradópolis', 'Praia Grande',
  'Pratânia', 'Presidente Alves', 'Presidente Bernardes', 'Presidente Epitácio', 'Presidente Prudente',
  'Presidente Venceslau', 'Promissão', 'Quadra', 'Quatá', 'Queiroz', 'Queluz', 'Quintana',
  'Rafard', 'Rancharia', 'Redenção da Serra', 'Regente Feijó', 'Reginópolis', 'Registro',
  'Restinga', 'Ribeira', 'Ribeirão Bonito', 'Ribeirão Branco', 'Ribeirão Corrente', 'Ribeirão do Sul',
  'Ribeirão dos Índios', 'Ribeirão Grande', 'Ribeirão Pires', 'Ribeirão Preto', 'Rifaina',
  'Rincão', 'Rinópolis', 'Rio Claro', 'Rio das Pedras', 'Rio Grande da Serra', 'Riolândia',
  'Riversul', 'Rosana', 'Roseira', 'Rubiácea', 'Rubinéia', 'Sabino', 'Sagres', 'Sales',
  'Sales Oliveira', 'Salesópolis', 'Salmourão', 'Saltinho', 'Salto', 'Salto de Pirapora',
  'Salto Grande', 'Sandovalina', 'Santa Adélia', 'Santa Albertina', 'Santa Bárbara d\'Oeste',
  'Santa Branca', 'Santa Clara d\'Oeste', 'Santa Cruz da Conceição', 'Santa Cruz da Esperança',
  'Santa Cruz das Palmeiras', 'Santa Cruz do Rio Pardo', 'Santa Ernestina', 'Santa Fé do Sul',
  'Santa Gertrudes', 'Santa Isabel', 'Santa Lúcia', 'Santa Maria da Serra', 'Santa Mercedes',
  'Santa Rita d\'Oeste', 'Santa Rita do Passa Quatro', 'Santa Rosa de Viterbo', 'Santa Salete',
  'Santana da Ponte Pensa', 'Santana de Parnaíba', 'Santo Anastácio', 'Santo André', 'Santo Antônio da Alegria',
  'Santo Antônio de Posse', 'Santo Antônio do Aracanguá', 'Santo Antônio do Jardim', 'Santo Antônio do Pinhal',
  'Santo Expedito', 'Santópolis do Aguapeí', 'Santos', 'São Bento do Sapucaí', 'São Bernardo do Campo',
  'São Caetano do Sul', 'São Carlos', 'São Francisco', 'São João da Boa Vista', 'São João das Duas Pontes',
  'São João de Iracema', 'São João do Pau d\'Alho', 'São Joaquim da Barra', 'São José da Bela Vista',
  'São José do Barreiro', 'São José do Rio Pardo', 'São José do Rio Preto', 'São José dos Campos',
  'São Lourenço da Serra', 'São Luís do Paraitinga', 'São Manuel', 'São Miguel Arcanjo', 'São Paulo',
  'São Pedro', 'São Pedro do Turvo', 'São Roque', 'São Sebastião', 'São Sebastião da Grama',
  'São Simão', 'São Vicente', 'Sarapuí', 'Sarutaiá', 'Sebastianópolis do Sul', 'Serra Azul',
  'Serra Negra', 'Serrana', 'Sertãozinho', 'Sete Barras', 'Severínia', 'Silveiras', 'Socorro',
  'Sorocaba', 'Sud Mennucci', 'Sumaré', 'Suzanápolis', 'Suzano', 'Tabapuã', 'Tabatinga',
  'Taboão da Serra', 'Taciba', 'Taguaí', 'Taiaçu', 'Taiúva', 'Tambaú', 'Tanabi', 'Tapiraí',
  'Tapiratiba', 'Taquaral', 'Taquaritinga', 'Taquarituba', 'Taquarivaí', 'Tarabai', 'Tarumã',
  'Tatuí', 'Taubaté', 'Tejupá', 'Teodoro Sampaio', 'Terra Roxa', 'Tietê', 'Timburi', 'Torre de Pedra',
  'Torrinha', 'Trabiju', 'Tremembé', 'Três Fronteiras', 'Tuiuti', 'Tupã', 'Tupi Paulista',
  'Turiúba', 'Turmalina', 'Ubarana', 'Ubatuba', 'Ubirajara', 'Uchoa', 'União Paulista',
  'Urânia', 'Uru', 'Urupês', 'Valentim Gentil', 'Valinhos', 'Valparaíso', 'Vargem',
  'Vargem Grande do Sul', 'Vargem Grande Paulista', 'Várzea Paulista', 'Vera Cruz', 'Vinhedo',
  'Viradouro', 'Vista Alegre do Alto', 'Vitória Brasil', 'Votorantim', 'Votuporanga', 'Zacarias',
];

function MunicipiosCarga({ formik, edit, view }) {
  const [municipioInput, setMunicipioInput] = useState('');
  const [ufPercursoInput, setUfPercursoInput] = useState('');
  const [showMunicipioInput, setShowMunicipioInput] = useState(false);
  const [showUfPercursoInput, setShowUfPercursoInput] = useState(false);
  const [filteredMunicipios, setFilteredMunicipios] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [ufPercursoPage, setUfPercursoPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const dropdownRef = useRef(null);

  const municipios = formik.values.municipios_carga || [];
  const ufsPercurso = formik.values.ufs_percurso || [];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMunicipioInputChange = (e) => {
    const value = e.target.value;
    setMunicipioInput(value);
    
    if (value.trim()) {
      const filtered = MUNICIPIOS_BRASIL.filter(municipio =>
        municipio.toLowerCase().includes(value.toLowerCase())
      ).slice(0, 10);
      setFilteredMunicipios(filtered);
      setShowDropdown(true);
    } else {
      setFilteredMunicipios([]);
      setShowDropdown(false);
    }
  };

  const handleSelectMunicipio = (municipio) => {
    setMunicipioInput(municipio);
    setShowDropdown(false);
  };

  const handleAddMunicipio = () => {
    if (municipioInput.trim()) {
      const newMunicipios = [...municipios, municipioInput.trim()];
      formik.setFieldValue('municipios_carga', newMunicipios);
      setMunicipioInput('');
      setShowMunicipioInput(false);
    }
  };

  const handleDeleteMunicipio = (index) => {
    const newMunicipios = municipios.filter((_, i) => i !== index);
    formik.setFieldValue('municipios_carga', newMunicipios);
  };

  const handleCancelMunicipio = () => {
    setMunicipioInput('');
    setShowMunicipioInput(false);
  };

  const handleAddUfPercurso = () => {
    if (ufPercursoInput.trim() && ufPercursoInput.trim().length === 2) {
      const newUfs = [...ufsPercurso, ufPercursoInput.trim().toUpperCase()];
      formik.setFieldValue('ufs_percurso', newUfs);
      setUfPercursoInput('');
      setShowUfPercursoInput(false);
    }
  };

  const handleDeleteUfPercurso = (index) => {
    const newUfs = ufsPercurso.filter((_, i) => i !== index);
    formik.setFieldValue('ufs_percurso', newUfs);
  };

  const handleCancelUfPercurso = () => {
    setUfPercursoInput('');
    setShowUfPercursoInput(false);
  };

  // Paginação para UFs de percurso
  const totalUfsPercursoPages = Math.ceil(ufsPercurso.length / itemsPerPage);
  const startIndex = ufPercursoPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedUfsPercurso = ufsPercurso.slice(startIndex, endIndex);

  return (
    <>
      {/* Seção UF's de percurso */}
      <Section
        title="UF's de percurso"
        rightContent={
          <Button
            label="Nova UF"
            onClick={() => setShowUfPercursoInput(true)}
            type="primary"
            width="120px"
            height="33px"
          />
        }
      >
        <UfPercursoContainer>
          {showUfPercursoInput && (
            <Row>
              <UfInputField>
                <TextField
                  label="UF"
                  name="uf_percurso_temp"
                  placeholder="UF"
                  value={ufPercursoInput}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    if (value.length <= 2) {
                      setUfPercursoInput(value);
                    }
                  }}
                  onBlur={() => {}}
                  disabled={view}
                  inputProps={{ maxLength: 2 }}
                  fullWidth
                  color="secondary"
                />
                <ActionButtons>
                  <ActionButton onClick={handleCancelUfPercurso}>✕</ActionButton>
                  <ActionButton onClick={handleAddUfPercurso}>✓</ActionButton>
                </ActionButtons>
              </UfInputField>
            </Row>
          )}

          {!showUfPercursoInput && ufsPercurso.length > 0 && (
            <>
              <UfListContainer>
                {paginatedUfsPercurso.map((uf, index) => {
                  const originalIndex = startIndex + index;
                  return (
                    <UfListItem key={originalIndex}>
                      <span>{uf}</span>
                      <DeleteButton onClick={() => handleDeleteUfPercurso(originalIndex)}>
                        <MdDelete size={18} />
                      </DeleteButton>
                    </UfListItem>
                  );
                })}
              </UfListContainer>

              <PaginationContainer>
                <PageNavigator
                  actual={ufPercursoPage}
                  total={totalUfsPercursoPages}
                  onChange={(page) => setUfPercursoPage(page.selected)}
                />
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ fontSize: '12px', fontFamily: 'Montserrat, sans-serif', color: '#7b7b7b' }}>Itens por página:</span>
                  <ItemsPerPageSelect
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setUfPercursoPage(0);
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </ItemsPerPageSelect>
                </div>
                <span style={{ fontSize: '12px', fontFamily: 'Montserrat, sans-serif', color: '#7b7b7b', marginLeft: 'auto' }}>
                  {ufsPercurso.length > 0
                    ? `${startIndex + 1}-${Math.min(endIndex, ufsPercurso.length)} de ${ufsPercurso.length} itens`
                    : '0-0 de 0 itens'}
                </span>
              </PaginationContainer>
            </>
          )}

          {!showUfPercursoInput && ufsPercurso.length === 0 && (
            <EmptyState>Nenhuma UF de percurso adicionada</EmptyState>
          )}
        </UfPercursoContainer>
      </Section>
    </>
  );
}

export default MunicipiosCarga;

